import { Filter, AlarmClock, Layers } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { FadeUp, SectionHeading } from "@/components/Reveal";

const ICONS = { Filter, AlarmClock, Layers };

const Problems = () => {
    const { content } = useSite();
    const { problems } = content;

    return (
        <section data-testid="problems-section" className="bg-mist py-20 sm:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <SectionHeading eyebrow="The Problem" heading={problems.heading} sub={problems.sub} />

                <div className="mt-14 grid gap-6 md:grid-cols-3">
                    {problems.items.map((item, i) => {
                        const Icon = ICONS[item.icon] || Filter;
                        return (
                            <FadeUp key={item.title} delay={i * 0.12}>
                                <article
                                    data-testid={`problem-card-${i}`}
                                    className="h-full rounded-2xl border border-slate-200 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
                                >
                                    <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-red-50">
                                        <Icon className="h-6 w-6 text-red-500" aria-hidden="true" />
                                    </span>
                                    <h3 className="mt-5 font-display text-xl font-bold text-navy">{item.title}</h3>
                                    <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">{item.text}</p>
                                </article>
                            </FadeUp>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Problems;
